import type { CoinDetailContentfulEntryCollection } from "types/contentful";
import type { AllPricesResponse } from "./prices";

export const normalizeCoinSlugs = (
  slugsArray: CoinDetailContentfulEntryCollection
): string[] => {
  const normalisedSlugsArray: string[] = [];

  if (slugsArray.items) {
    slugsArray.items.forEach((slugField) => {
      normalisedSlugsArray.push(slugField.fields.slug);
    });
  }

  return normalisedSlugsArray;
};

export function getTop9CoinsExcludingSlug(
  coins: AllPricesResponse,
  slug: string
) {
  const coinsSortedAndFilteredByVolume = coins
    .filter((coin) => coin.isTrading === true)
    .sort(
      (a, b) =>
        parseFloat("volume" in b ? b.volume.value : "0") -
        parseFloat("volume" in a ? a.volume.value : "0")
    );

  const top9Coins = coinsSortedAndFilteredByVolume
    .filter((entry) => entry.slug !== slug)
    .slice(0, 9);

  return top9Coins;
}
